import { useSlate } from 'slate-react';
import { isBlockActive, toggleBlock, isSimpleBlockActive } from 'app/slate/functions';
import { forwardRef } from 'react';
import { toggleList } from 'app/slate/extensions/list';

const LIST_TYPES = ['numbered-list', 'bulleted-list'];

export const BlockButton = forwardRef(({ format, icon, css, styling }, ref) => {
  const editor = useSlate();
  return (
    <button
      ref={ref}
      className={`${css} ${
        isBlockActive(editor, format, styling) || ((format === 'numbered-list' || format === 'bulleted-list') && isSimpleBlockActive(editor, format))
          ? 'active'
          : ''
      }`}
      onMouseDown={(event) => {
        event.preventDefault();
        if (LIST_TYPES.includes(format)) {
          toggleList(editor, format);
          return;
        }
        toggleBlock(editor, format, styling);
      }}
    >
      <i className={`fa-regular fa-${icon}`} />
    </button>
  );
});
